import { useGetSessionQuery } from "@/src/store/apis/auth";
import { useGetCommonCodeViaCodeNameQuery } from "@/src/store/apis/common";
import { styled } from "styled-components";
import BankDetails from "./components/BankDetails";
import BasicInformation from "./components/BasicInformation";
import PhotoTypeLabelsCard from "./components/PhotoTypeLabelsCard";
import SignatureManagement from "./components/SignatureManagement";
import TermsOfSales from "./components/TermsOfSales";

interface CompanyManagementProps {
  role: "EXPORTER" | "IMPORTER";
}

const CompanyManagement: React.FC<CompanyManagementProps> = ({ role }) => {
  // Prefetch session data
  useGetSessionQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  // Prefetch country codes for dialogs
  useGetCommonCodeViaCodeNameQuery(
    {
      codeName: "COUNTRY",
    },
    {
      refetchOnMountOrArgChange: true,
    },
  );

  // Prefetch main categories for dialogs
  useGetCommonCodeViaCodeNameQuery(
    {
      codeName: "MAIN_CATEGORY",
    },
    {
      refetchOnMountOrArgChange: true,
    },
  );

  return (
    <FlexRow>
      {/* Left Column */}
      <FlexColumn>
        <BasicInformation role={role} />
        <TermsOfSales role={role} />
      </FlexColumn>

      {/* Right Column */}
      <FlexColumn>
        <SignatureManagement role={role} />
        <BankDetails role={role} />
        <PhotoTypeLabelsCard role={role} />
      </FlexColumn>
    </FlexRow>
  );
};

export default CompanyManagement;

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const FlexRow = styled.div`
  display: flex;
  gap: 16px;
`;
